import React from 'react'

import { PriceString, ProfitString } from '@fourthwall/components'
import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString'

import type { Transaction } from '../../Transactions.types'
import { transactionTypeTexts } from '../../consts'
import { TransactionIdLink } from '../TransactionIdLink/TransactionIdLink'
import * as S from './TransactionsListItem.styled'

type TransactionsListItemProps = {
  transactionItem: Transaction
}

export const TransactionsListItem = ({ transactionItem }: TransactionsListItemProps) => {
  return (
    <S.Container>
      <S.LeftSide>
        <div>{transactionTypeTexts[transactionItem.type]}</div>
        <TransactionIdLink transaction={transactionItem} />
        <S.Date>
          <TimezonedDateString
            date={transactionItem.transactionAt}
            format="MMM DD, YYYY h:mm A"
            withTimezoneAbbreviation={false}
          />
        </S.Date>
      </S.LeftSide>
      <S.RightSide>
        <S.PriceWrapper>
          {transactionItem.type === 'CREATOR_CHARGE' ? (
            <PriceString value={transactionItem.value.value} />
          ) : (
            <ProfitString value={transactionItem.value.value} />
          )}
        </S.PriceWrapper>
        <S.SecondaryPriceWrapper>
          <PriceString value={transactionItem.balance.value} />
        </S.SecondaryPriceWrapper>
      </S.RightSide>
    </S.Container>
  )
}
